<template>
    <div :class="['for-student-box', {'no-auth-btn': homeData.auth}]">
        <tc-navbar
            class="navbar-box"
            nav-title="同程校园"
            initColor="rgba(0, 0, 0, 0.8)"
            initLeftIcon="//file.40017.cn/appresource/image/forStudent/new/icon_navi_back@2x.png"
            initRightIcon="//file.40017.cn/appresource/image/forStudent/new/icon_navi_share@2x.png"
            :status-height="statusHeight"
            @rightClick="rightClick">
        </tc-navbar>
        <div class="head-box">
            <img :src="homeData.auth ? '//file.40017.cn/appresource/image/forStudent/new/bg_s_privilege.png' : '//file.40017.cn/appresource/image/forStudent/new/bg_header@3x.png'" alt="">
            <div class="rule-btn-box" @click="showRuleBox">
                <div class="rule-btn" >规 则</div>
            </div>
            <notice :notices="configInfo.notices || []" @setTrack="setTraceEvent"></notice>
        </div>
        <template v-if="!homeData.auth">
            <tabRights :class="{'hasNotices': configInfo.notices && configInfo.notices.length > 0}" @setTrack="setTraceEvent"></tabRights>
            <div class="btn-box" @click="toAuth">
                <p class="btn-txt">立即认证 领专属特权</p>
                <span class="tip-txt">填写仅需20s 认证秒通过</span>
            </div>
        </template>
        <template v-else>
            <studentInfo
                :class="{'hasNotices': configInfo.notices && configInfo.notices.length > 0}"
                :data="studentInfo"
                @setTrack="setTraceEvent">
            </studentInfo>
            <exclusiveRights
                :data="homeData.authRight || []"
                :isAuth="homeData.auth"
                :isChsiAuth="homeData.chsiAuth"
                @showDetail="showPopupBox"
                @setTrack="setTraceEvent">
            </exclusiveRights>
            <otherAct :dataEat="configInfo.eat || []" :dataPlay="configInfo.play || []" @setTrack="setTraceEvent"></otherAct>
            <banner :bannerList="configInfo.bannerList || []" @setTrack="setTraceEvent"></banner>
        </template>
        <commonPopup ref="commonPopup" :content="popCont" :title="popTitle" :isShowBtn="isShowBtn" :isShowEmptyBtn="true" :isShowfillBtn="isShowfillBtn" @setTrack="setTraceEvent"/>
        <wxBindPopup ref="wxBindPopup" :isShowBtn="true" :loginInfo="loginInfo" @setTrack="setTraceEvent"/>
        <otherPopup ref="otherPopup" :title="otherPopTitle" :data="homeData.authRight || []" :isChsiAuth="homeData.chsiAuth" :isShowBtn="true" @setTrack="setTraceEvent"/>
        <tc-new-share
            :show="isShare"
            :esay-type="['WeChat','WechatMoments','QqChat']"
            :share-info="shareInfo"
            @close="closeShare"
            @handleClick="handleClick">
        </tc-new-share>
    </div>
</template>

<script>
import { Navbar, Empty, NewShare } from 'tc-business';
import request from '@/utils/request'
import { toPage, randomString } from "@/utils/tools";
import { Icon, Toast } from 'vant';
import commonPopup from './components/commonPopup.vue';
import wxBindPopup from './components/wxBindPopup.vue';
import otherPopup from './components/otherPopup.vue';
import tabRights from './components/tabRights.vue';
import banner from './components/banner.vue';
import notice from './components/notice.vue';
import exclusiveRights from './components/exclusiveRights.vue';
import studentInfo from './components/studentInfo.vue';
import otherAct from './components/otherAct.vue';

export default {
    name: 'newForStudents',
    components: {
        [Navbar.name]: Navbar,
        [Empty.Component.name]: Empty.Component,
        [NewShare.name]: NewShare,
        [Icon.name]: Icon,
        commonPopup,
        wxBindPopup,
        otherPopup,
        tabRights,
        banner,
        notice,
        exclusiveRights,
        studentInfo,
        otherAct
    },
    data() {
        return {
            statusHeight: 20,
            loginInfo: {},
            deviceInfo: {},
            homeData: {},
            studentInfo: {},
            configInfo: {},
            popTitle: '',
            popCont: '',
            isShowBtn: false,
            isShowfillBtn: false,
            otherPopTitle:'',
            isShare: false,
            shareInfo: {
                imageUrl: 'https://file.40017.cn/appresource/image/forStudent/new/img_share.jpg', // 必传
                url: `https://m.17u.cn/app/links/web/main_${randomString(18)}?url=https%3A${encodeURIComponent(process.env.VUE_APP_BASE_H5_URL)}%2Fpropublic%2FforStudent%3Ftcwvclogin&wakeNew=1&wakeRetry=1&wakePwdId=0`, // 必传
                title: '快来领学生专属出行省钱卡啦！', // 非必传
                desc: '叠加学生折扣更划算哦~', // 非必传
            },
        }
    },
    created() {
        this.$loading.show();
        // this.getHomeInfo()
        // this.getConfigInfo()
        let isFirst = true
        _multi_bridge_ready(() => {
            window?._tc_bridge_user?.get_device_info({
                param: {},
                callback: (data)=> {
                    const dbody = JSON.parse(data.CBData);
                    const deviceInfo = dbody.deviceInfo;
                    this.deviceInfo = dbody.deviceInfo;
                    console.log('设备信息', this.deviceInfo);
                    if (window._tc_bridge_public.platform == 1) {
                        // 安卓
                        this.statusHeight = deviceInfo.statusBarHeightPx / 3;
                    } else {
                        this.statusHeight = deviceInfo.statusBarHeightPx / 1;
                    }
                    
                    window._tc_bridge_user.user_login({
                        callback: (res) => {
                            const data = JSON.parse(res.CBData);
                            this.loginInfo = data.memberInfo
                            const userKey = data.memberInfo.memberId
                            const nickName = data.memberInfo.nickName
                            console.log('1111登录信息111111111', this.loginInfo);
                            if (userKey) {
                                this.getHomeInfo()
                                this.getConfigInfo()
                            } else {
                                window._tc_bridge_util.set_webview_back()
                            }
                        }
                    })
                }
            });
            if (window?._tc_bridge_public?.isTc) {
                window._tc_web_bar = {
                    //头部
                    tag_isStop: data => {
                        if (!isFirst) {
                            if (data.isStop == 'true' || data.isStop === true) {
                                //失活
                            } else {
                                //激活..
                                this.showGift = false
                                this.getHomeInfo()
                            }
                        }
                        isFirst = false
                    },
                }
            }
            window?._tc_bridge_util?.set_webview_info({
                "param": {
                    "webview": {
                        "dragAble": "false"
                    }
                }
            })
        })
    },
    mounted() {

    },
    methods: {
        rightClick() {
            this.isShare = true
        },
        closeShare() {
            this.isShare = false
            this.setTraceEvent({
                action: 'students_share_click',
                label: '学生专区分享点击',
                value: {"channel":"学生专区","scene":"公共","site": '取消'}
            })
        },
        handleClick(type) {
            console.log('分享type', type);
            let clickSite = ''
            if (type === 'WeChat') {
                clickSite = '微信好友'
            } else if (type === 'WechatMoments') {
                clickSite = '朋友圈'
            } else {
                clickSite = 'QQ好友'
            }
            this.setTraceEvent({
                action: 'students_share_click',
                label: '学生专区分享点击',
                value: {"channel":"学生专区","scene":"公共","site": clickSite}
            })
        },
        showRuleBox() {
            this.popTitle = '活动规则'
            this.popCont = this.configInfo.rule
            this.isShowBtn = false
            this.isShowfillBtn = false
            this.$refs.commonPopup.show()
            this.setTraceEvent({
                action: 'students_activityrule_click',
                label: '活动规则点击',
                value: ''
            })
        },
        showPopupBox(popupInfo) {
            console.log('1------------', popupInfo);
            this.popTitle = popupInfo.interaction[0].title
            this.popCont = popupInfo.interaction[0].content
            this.isShowBtn = true
            this.isShowfillBtn = popupInfo.isLock
            this.$refs.commonPopup.show()
        },
        getRightLockState(rigthList) {
            rigthList.forEach((item) => {
                if (this.homeData.auth && +item.type === 1 || this.homeData.chsiAuth && +item.type === 2) {
                    item.isLock = false
                } else {
                    item.isLock = true
                }
            })
        },
        getHomeInfo(isFresh) {
            request({
                url: `${process.env.VUE_APP_BASE_URL}/backendActivity/student/index`,
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    platTag: 'tcapp',
                    secureToken: this.loginInfo.memberIdNew,
                    deviceId: this.deviceInfo.deviceId
                },
                data: {}
            }).then((res) => {
                console.log('homeData111', res);
                if (+(res?.code) === 0 && res.data) {
                    this.homeData = res.data
                    this.studentInfo = {
                        name: res.data.name,
                        avatar: res.data.avatar,
                        school: res.data.school
                    }
                    let state = ''
                    if (!isFresh) {
                        if (!res.data.bind && (!this.homeData.auth)) {
                            state = '未绑定微信/未认证'
                        } else if ((res.data.bind) && !this.homeData.auth) {
                            state = '未认证'
                        } else if (this.homeData.auth) {
                            state = '已认证'
                        } else if (!res.data.bind) {
                            state = '未绑定微信'
                        }
                        this.setTraceEvent({
                            action: 'students_pageshow',
                            label: '学生专区页面曝光',
                            value: {"channel":"学生专区","scene":"公共","state": state,"refid": this.$route.query.refid}
                        })
                        if (!res.data.bind) {
                            this.$refs.wxBindPopup.show()
                            this.setTraceEvent({
                                action: 'wechat_bind_show',
                                label: '微信绑定弹窗曝光',
                                value:''
                            })
                        }
                        // 是否来自学生认证页面
                        const isFromStuCertification = sessionStorage.getItem('gotoStudentAuth')
                        sessionStorage.removeItem('gotoStudentAuth')
                        if (+isFromStuCertification === 1 && this.homeData.auth) {
                            this.otherPopTitle = '基础信息校验成功'
                            this.$refs.otherPopup.show(this.homeData.chsiAuth)
                        }
                        // 是否来自学生学籍认证页面
                        const isFromStuRegistration  = sessionStorage.getItem('gotoStudentChsiAuth')
                        sessionStorage.removeItem('gotoStudentChsiAuth')
                        if (+isFromStuRegistration === 1 && this.homeData.chsiAuth) {
                            this.otherPopTitle = '学籍信息校验成功'
                            this.$refs.otherPopup.show(this.homeData.chsiAuth)
                        }
                    }
                    this.getRightLockState(this.homeData.authRight)
                } else {
                    Toast("获取信息失败，请稍后再试",{duration: 1000})
                }
                this.$loading.hide();
            }).catch((err)=> {
                this.$loading.hide();
            })
        },
        getConfigInfo(isFresh) {
            request({
                url: `${process.env.VUE_APP_BASE_URL}/backendActivity/student/config`,
                method: 'post',
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    platTag: 'tcapp',
                    secureToken: this.loginInfo.memberIdNew,
                    deviceId: this.deviceInfo.deviceId
                },
                data: {}
            }).then((res) => {
                console.log('ConfigInfo',res);
                if (+(res?.code) === 0 && res.data) {
                    this.configInfo = res.data
                } else {
                    Toast("获取信息失败，请稍后再试",{duration: 1000})
                }
                this.$loading.hide();
            }).catch((err)=> {
                this.$loading.hide();
            })
        },
        toAuth(data) {
            if(!this.homeData.bind) {
                this.$refs.wxBindPopup.show()
                this.setTraceEvent({
                    action: 'wechat_bind_show',
                    label: '微信绑定弹窗曝光',
                    value:''
                })
            } else {
                sessionStorage.setItem('gotoStudentAuth', 1)
                this.setTraceEvent({
                    action: 'students_button_click',
                    label: '学生认证按钮点击',
                    value:''
                })
                toPage(`/StuCertification?refid=${this.$route.query.refid}`)
            }
        },
        //事件埋点
        setTraceEvent(eventInfo) {
            const { category = 'cvg2021_apppublic_students', action = '', label = '', value = '', pagename = 'TAPP学生专区' } = eventInfo
            console.log('事件埋点', eventInfo)
            window?._tc_bridge_util?.set_category_event({
                "param": {
                    category,
                    action,
                    optLabel: label,
                    optValue: typeof value === 'object' ? JSON.stringify(value) : value,
                    pagename
                }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.for-student-box {
    background: #C6F2F7;
    padding-bottom: calc(100px + constant(safe-area-inset-bottom));
    padding-bottom: calc(100px + env(safe-area-inset-bottom));
    min-height: calc(100vh - 100px);
    &.no-auth-btn {
        padding-bottom: 10px;
    }
    .head-box {
        position: relative;
        z-index: 0;
        height: 333px;
        overflow: hidden;
        img {
            // height: 370px;
            width: 100vw;
            object-fit: contain;
        }
        .rule-btn-box {
            position: absolute;
            top: 130px;
            right: -2px;
            padding: 10px 0 10px 18px;
            .rule-btn {
                width: 20px;
                // height: 40px;
                padding: 6px 0;
                text-align: center;
                color: #fff;
                background: rgba(0, 0, 0, 0.51);
                border-radius: 6px 0 0 6px;
                // writing-mode: vertical-lr;
                font-size: 14px;
                line-height : 1.3;
            }
        }
    }
    .hasNotices {
        margin-top: -71px;
    }
   
    .btn-box {
        position: fixed;
        left: 0;
        right: 0;
        bottom: 0;
        height: 80px;
        background: #fff;
        // padding-top: 10px;
        box-shadow: 0 -2px 5px 0 #afd7dc4d;
        padding-bottom: constant(safe-area-inset-bottom);
        padding-bottom: env(safe-area-inset-bottom);
        .btn-txt {
            position: relative;
            // width: 291px;
            height: 80px;
            // background-image: linear-gradient(270deg, #2AF2CA 0%, #DFFE51 100%);
            background: url(https://file.40017.cn/appresource/image/forStudent/new/bg_btn@2x.png) no-repeat;
            background-size: cover;
            // border: 1px solid #000000;
            // box-shadow: 0 1px 0 0 #ffffff59;
            border-radius: 25px;
            text-align: center;
            line-height: 70px;
            font-weight: 600;
            font-size: 18px;
            color: #004D36;
            margin: 0 19px;
        }
        .tip-txt {
            position: absolute;
            top: -3px;
            right: 42px;
            font-size: 10px;
            line-height: 14px;
            color: #FFFFFF;
            background: #8C22FF;
            border-radius: 9px 10px 10px 0;
            padding: 3px 6.5px 3px;
        }
    }
}
</style>>
